enum TrackedEvent {
  IMPRESSION = 'impression',
  PROGRESS = 'progress',
  FIRST_QUARTILE = 'firstQuartile',
  MIDPOINT = 'midpoint',
  THIRD_QUARTILE = 'thirdQuartile',
  COMPLETE = 'complete',
  CLICK = 'click',
  ERROR = 'error',
}

export default TrackedEvent;
